import { CIcon } from '~/icons/types'

export const ciMobile: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d: 'M13.5 18.75h-3a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    },
    {
      d:
        'M15.375.75h-6.75A3.375 3.375 0 0 0 5.25 4.125v15.75a3.375 3.375 0 0 0 3.375 3.375h6.75a3.375 3.375 0 0 0 3.375-3.375V4.125A3.375 3.375 0 0 0 15.375.75ZM16.5 19.875c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 0 1 7.5 19.875V4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'mobile',
  type: 'solid'
}
